'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formDate = require('components/formComponents/formDate');

var _formDate2 = _interopRequireDefault(_formDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpireDateField = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(ExpireDateField, _PureComponent);

  function ExpireDateField() {
    (0, _classCallCheck3.default)(this, ExpireDateField);
    return (0, _possibleConstructorReturn3.default)(this, (ExpireDateField.__proto__ || (0, _getPrototypeOf2.default)(ExpireDateField)).apply(this, arguments));
  }

  (0, _createClass3.default)(ExpireDateField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          className = _props.className,
          inputProps = _props.inputProps;

      // disableOnClickOutside=false breaks dnd events

      return _react2.default.createElement(_reduxForm.Field, {
        className: className,
        inputProps: inputProps,
        name: 'expiryDate',
        noIndent: true,
        hideLabel: true,
        component: _formDate2.default,
        placeholder: t('Expire Date') + '*',
        required: true,
        disableOnClickOutside: true
      });
    }
  }]);
  return ExpireDateField;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  inputProps: {}
}, _temp)) || _class);
exports.default = ExpireDateField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/ExpireDateField.js
// module id = 2079
// module chunks = 1